import { Base } from "@studiometa/js-toolkit";
import { tns } from "tiny-slider";
class Slider extends Base {
  mounted() {
    this.options = JSON.parse(this.$options.config);
    tns({
      container: this.$refs.container,
      center: false,
      controls: false,
      loop: this.options ? this.options.loop : false,
      autoplay: true,
      mode: this.options ? this.options.mode : "carousel",
      nav: this.options ? this.options.nav : true,
      autoplayTimeout: this.options ? this.options.autoplayTimeout : true,
      items: 1,
      mouseDrag: true,
      autoplayButtonOutput: false,
      navContainer: this.$refs.navContainer
    });
  }
}
Slider.config = {
  name: "Slider",
  refs: ["container", "navContainer"],
  options: {
    config: {
      type: String,
      default: "{}"
    }
  }
};
export {
  Slider as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
